var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-doc-share-palette-component" }, [
    _c("div", { staticClass: "room-doc-share-palette" }, [
      _c("ul", { staticClass: "room-doc-share-palette-list" }, [
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.lazer"),
                  expression: "$t('doc.palette.lazer')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button laser-pointer",
              class: { selected: _vm.selectedTab == "LaserPointer" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.useLaserPointer.apply(null, arguments)
                },
              },
            }),
          ]),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.pen"),
                  expression: "$t('doc.palette.pen')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button pencil",
              class: { selected: _vm.selectedTab == "Pencil" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.usePencil.apply(null, arguments)
                },
              },
            }),
          ]),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.highlighter"),
                  expression: "$t('doc.palette.highlighter')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button highlighter",
              class: { selected: _vm.selectedTab == "Highlighter" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.useHighlighter.apply(null, arguments)
                },
              },
            }),
          ]),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.figures"),
                  expression: "$t('doc.palette.figures')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button figures",
              class: { selected: _vm.figureList.includes(_vm.selectedTab) },
            }),
          ]),
          _c(
            "ul",
            { staticClass: "room-doc-share-palette-sub-list" },
            _vm._l(_vm.figureList, function (figure, i) {
              return _c(
                "li",
                { key: i, staticClass: "room-doc-share-palette-sub-item" },
                [
                  _c("button", {
                    class: [
                      "room-doc-share-palette-sub-button",
                      figure == "TwoLines" ? "two-lines" : figure.toLowerCase(),
                    ],
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.useFigure(figure)
                      },
                    },
                  }),
                ]
              )
            }),
            0
          ),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.text"),
                  expression: "$t('doc.palette.text')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button text",
              class: { selected: _vm.selectedTab == "Text" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.useText(20)
                },
              },
            }),
          ]),
          _c("ul", { staticClass: "room-doc-share-palette-sub-list" }, [
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button text xs",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.useText(20)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button text s",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.useText(30)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button text m",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.useText(40)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button text l",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.useText(50)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button text xl",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.useText(60)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.eraser"),
                  expression: "$t('doc.palette.eraser')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button eraser",
              class: { selected: _vm.selectedTab == "Eraser" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.useEraser.apply(null, arguments)
                },
              },
            }),
          ]),
          _c("ul", { staticClass: "room-doc-share-palette-sub-list" }, [
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button eraser",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.clearCanvas.apply(null, arguments)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.zoom"),
                  expression: "$t('doc.palette.zoom')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button zoom",
            }),
          ]),
          _c("ul", { staticClass: "room-doc-share-palette-sub-list" }, [
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button zoom in",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.zoom(0.1)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button zoom out",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.zoom(-0.1)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button zoom fit",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.zoomFit.apply(null, arguments)
                  },
                },
              }),
            ]),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button zoom origin",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.zoomOri.apply(null, arguments)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.move"),
                  expression: "$t('doc.palette.move')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button move",
              class: { selected: _vm.selectedTab === "Move" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.useMove.apply(null, arguments)
                },
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "room-doc-share-palette-divider" }),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.color"),
                  expression: "$t('doc.palette.color')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button color",
              style: { "--selectedColor": _vm.selectedColor },
            }),
          ]),
          _c(
            "ul",
            { staticClass: "room-doc-share-palette-sub-list color" },
            _vm._l(_vm.$parent.$refs.csCanvas.colorList, function (color) {
              return _c(
                "li",
                { key: color, staticClass: "room-doc-share-palette-sub-item" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "room-doc-share-palette-sub-button color",
                      class: [
                        { selected: _vm.selectedColor == color },
                        "_" + color.substr(1).toLowerCase(),
                      ],
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changeColor(color)
                        },
                      },
                    },
                    [_c("span", { style: { "background-color": color } })]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _c("li", { staticClass: "room-doc-share-palette-item" }, [
          _c("div", { staticClass: "room-doc-share-palette-button-wrapper" }, [
            _c("button", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: _vm.$t("doc.palette.thickness"),
                  expression: "$t('doc.palette.thickness')",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "room-doc-share-palette-button thickness",
            }),
          ]),
          _c("ul", { staticClass: "room-doc-share-palette-sub-list" }, [
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass:
                  "room-doc-share-palette-sub-button thickness minus",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.$parent.$refs.csCanvas.strokeWidth = Math.max(
                      parseInt(_vm.$parent.$refs.csCanvas.strokeWidth, 10) - 10,
                      1
                    )
                  },
                },
              }),
            ]),
            _vm.$parent.$refs.csCanvas.csCanvas?.getCurrentToolkit().style
              .lineWidth
              ? _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "room-doc-share-palette-sub-button thickness range",
                    },
                    [
                      _c("input", {
                        attrs: { type: "range", min: "1", max: "70" },
                        domProps: { value: _vm.selectedStrokeWidth },
                        on: { input: _vm.changeStrokeWidth },
                      }),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("li", { staticClass: "room-doc-share-palette-sub-item" }, [
              _c("button", {
                staticClass: "room-doc-share-palette-sub-button thickness plus",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.$parent.$refs.csCanvas.strokeWidth = Math.min(
                      parseInt(_vm.$parent.$refs.csCanvas.strokeWidth, 10) + 10,
                      70
                    )
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }